/**
 * client/src/lib/recovery-duties-api.ts
 *
 * Client fetcher for the guardian-scoped recovery-duties feed
 * (`GET /api/recovery/guardian/pending`, server/routes/recovery.routes.ts,
 * PR 1 Task 1 [AC-1, AC-2]). Mirrors `handshake-duties-api.ts`'s shape.
 */

import { apiRequest } from "@/lib/queryClient";

export interface RecoveryPendingDuty {
  sessionId: string;
  connectionId: string;
  protectedUserId: string;
  displayName: string;
  expiresAt: string;
  alreadyApproved: boolean;
}

export interface RecoveryPendingDutiesResponse {
  duties: RecoveryPendingDuty[];
}

export const RECOVERY_DUTIES_QUERY_KEY = ["recovery", "guardian", "pending"] as const;

/**
 * Timeout for the guardian duties fetch (fix round, F5 / ledger #50
 * precedent — same value `auth-me.ts`'s `AUTH_ME_TIMEOUT_MS` uses). Without
 * this, a hung connection leaves every consumer of this feed — the
 * recovery-approval page included — parked on a permanent loading state
 * with no way to recover short of a manual reload.
 */
export const RECOVERY_DUTIES_TIMEOUT_MS = 10_000;

export function getRecoveryPendingDuties(): Promise<RecoveryPendingDutiesResponse> {
  return apiRequest<RecoveryPendingDutiesResponse>("/api/recovery/guardian/pending", undefined, {
    timeoutMs: RECOVERY_DUTIES_TIMEOUT_MS,
  });
}
